export const MAPPING_READ_REQUEST = "MAPPING_READ_REQUEST";
export const MAPPING_READ = "MAPPING_READ";
export const MAPPING_CREATE = "MAPPING_CREATE";
export const MAPPING_CREATE_REQUEST = "MAPPING_CREATE_REQUEST";
